import { useState } from 'react';
import { useManagement } from './hooks/management';

import T from './T';

const debugCredentials = { email: 'toto', password: 'tata' };

const withFullscreenWrapper = (Component) => (props) => (
  <div className='center-items flex bg-gray-800 h-full'>
    <Component {...props} />
  </div>
);

const Login = withFullscreenWrapper(({ onSuccess }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const management = useManagement();

  const handleSubmit = () => {
    if (email && password) {
      management
        .open({ email, password })
        .then((response) => response && onSuccess(response));
    } else if (debugCredentials) {
      // TODO ne devrait être possible qu'en dev
      management
        .open(debugCredentials)
        .then((response) => response && onSuccess(response));
    }
  };
  const handleUpdate =
    (setter) =>
    ({ target }) => {
      management.clearMessage('');
      setter(target.value);
    };
  return (
    <form
      className='Login m-auto max-w-100 rounded-md border border-black bg-gray-100 p-5 shadow-sm'
      action={handleSubmit}
    >
      <fieldset className='email m-1'>
        <legend>{T('email')}</legend>
        <input
          className='rounded-sm border border-black bg-white'
          type='text'
          value={email}
          onChange={handleUpdate(setEmail)}
          autoFocus
        />
      </fieldset>
      <fieldset className='password m-1'>
        <legend>{T('password')}</legend>
        <input
          className='rounded-sm border border-black bg-white'
          type='password'
          value={password}
          onChange={handleUpdate(setPassword)}
        />
      </fieldset>
      <div className='error m-1'>{T(management.message)}</div>
      <button
        className='btn m-1'
        type='submit'
        disabled={management.pending}
      >
        {T('open')}
      </button>
    </form>
  );
});

export default Login;
